module.exports = __webpack_public_path__ + "img/pack.aa19950c.png";